import React, { useEffect, useState } from "react";

const LogoBadge = ({ src, alt, fallback, className = "" }) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  return (
    <div className={`logo-badge ${className}`.trim()}>
      {src && !failed ? (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          onError={() => setFailed(true)}
        />
      ) : (
        <span aria-hidden="true">{fallback || "?"}</span>
      )}
    </div>
  );
};

export default LogoBadge;
